import axios from '../axios';

class Api {
    static getAllVoorspellingsplaats () {
        return axios.get('/voorspellingsplaats/allbyplaats');
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/voorspellingsplaats.js